import React from 'react'
import PropTypes from 'prop-types'

import CONFIG from '../../../config'
import {getLanguageScope} from '../../../helpers'

const _i18n = getLanguageScope('products');

import {List, Image, Header, Input, Icon, Grid} from 'semantic-ui-react'
import LazyImage from '../../shared/LazyImage/components/LazyImage'

import ListPagination from "../../shared/ListPagination/containers/ListPaginationContainer";
import CategoryDefaultImage from '../../../assets/category_default_image.png'
import _ from 'lodash'

class ProductsView extends React.Component {
  constructor(props) {
    super(props);

    this.searchInput = null;
  }

  componentDidMount() {
    const {loadProducts, appReset} = this.props;

    this.searchInput.focus();

    appReset();
    return loadProducts();
  }

  renderFavorites() {
    const {favorites, next} = this.props;

    const favoritesViews = _.map(favorites, ({icon, title, name, product_id, app_guid, weight}, key) => {
      const image = icon ? `${CONFIG.STATIC_PATH}${icon}` : CategoryDefaultImage;
      return (
        <List.Item as='a' onClick={() => next(app_guid, product_id)} key={key}>
          <List.Content verticalAlign='middle'>
            <Header as={'h5'}>
              <LazyImage size='mini' src={image}/> {name || title}
            </Header>
          </List.Content>
        </List.Item>
      )
    });

    return (
      <ListPagination
        items={favoritesViews}
        itemsPerPage={10}
        noItemsMessage={_i18n('no_favorites')}
        listStyles={{"minHeight": 200}}
      />
    );
  }

  render() {
    const {products, next, searchTerm, changeSearchTerm, favorites} = this.props;

    const productsViews = _.map(products, ({icon, title, name, product_id, app_guid, weight}, key) => {
      const image = icon ? `${CONFIG.STATIC_PATH}${icon}` : CategoryDefaultImage;
      return (
        <List.Item as='a' onClick={() => next(app_guid, product_id)} key={key}>
          <List.Content verticalAlign='middle'>
            <Header as={'h5'}>
              <LazyImage size='mini' src={image}/> {name || title}
            </Header>
          </List.Content>
        </List.Item>
      )
    });

    let action = {};
    if (searchTerm) action = {
      action: {
        color: 'red',
        labelPosition: 'right',
        icon: 'close',
        content: _i18n('reset'),
        onClick: () => changeSearchTerm('')
      }
    };

    let hasFavorites = favorites && favorites.length;

    return (
      <Grid divided='vertically'>
        <Grid.Row columns={hasFavorites ? 2 : 1}>

          {hasFavorites ?
            <Grid.Column style={{marginTop: 24}}>
              <Header as='h3'>{_i18n('favorites')}</Header>
              {this.renderFavorites()}
            </Grid.Column> : null}

          <Grid.Column>
            <Input
              style={{marginBottom: 20}}
              fluid
              ref={ref => this.searchInput = ref}
              iconPosition='left'
              icon='search'
              color={'red'}
              value={searchTerm}
              onChange={(e, {name, value}) => changeSearchTerm(value)}
              placeholder={_i18n('search')}
              {...action}
            />

            <ListPagination
              items={productsViews}
              columns={1}
              itemsPerPage={10}
              noItemsMessage={_i18n('no_products')}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

    );
  }
}

ProductsView.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object),
  setLoadingContent: PropTypes.func,
  next: PropTypes.func
};

export default ProductsView


// WEBPACK FOOTER //
// ./src/components/Products/components/ProductsView.js